import React from "react";
import { MGTypography, TMGTypographyProps } from "../MGTypography/MGTypography";
import {
  MGSubtitleStyleDefinitions,
  TMGSubtitleStyleDefinitions,
} from "../../typography";

export type TMGSubtitleProps = TMGTypographyProps & {
  subtitleStyleDefinition: TMGSubtitleStyleDefinitions;
};

export const MGSubtitle = ({ subtitleStyleDefinition, ...props }: TMGSubtitleProps) => (
  <MGTypography
    {...props}
    componentName="mg-subtitle"
    definition={MGSubtitleStyleDefinitions[subtitleStyleDefinition]}
  />
);
